module.exports = __webpack_public_path__ + "img/106.0b8ec706.jpg";